// Bilingual content (PT / EN) for the LAWORK website.
// Editorial voice, human, direct, low on buzzwords. Peri-inspired.

const IMAGES = {
  heroFeatured:
    'https://images.unsplash.com/photo-1770943558988-2c605d6bd5a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  aboutTeam1:
    'https://images.unsplash.com/photo-1491975474562-1f4e30bc9468?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  aboutTeam2:
    'https://images.unsplash.com/photo-1594732832278-abd644401426?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  closingScene:
    'https://images.unsplash.com/photo-1681949270990-cecd4728d2e0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  detailHands:
    'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
};

export const IMG = IMAGES;

const contactInfo = {
  email: 'contato@lawork.ia.br',
  phone: '(68) 992351817',
  whatsapp: '5568992351817',
};

// Real partners / clients (from Lawork's past projects), shown as an editorial roll call.
const partners = [
  'Transparência Internacional Brasil',
  'Instituto Talanoa',
  'Comitê Chico Mendes',
  'SEICT Acre',
  'IMA Amazônia',
  'O Alerta Cidade',
];

export const translations = {
  pt: {
    code: 'pt',
    nav: {
      home: 'Início',
      about: 'Estudio',
      services: 'O que fazemos',
      portfolio: 'Trabalhos',
      contact: 'Contato',
      cta: 'Fale com a gente',
    },
    home: {
      overline: 'Estúdio de produtos digitais',
      heroTitle: 'A gente constrói o que ainda não existe.',
      heroLead:
        'A Lawork é um estúdio pequeno, formado em maioria por mulheres, que desenha e desenvolve produtos digitais para empresas, governos e organizações que precisam sair do lugar.',
      heroPrimaryCta: 'Ver trabalhos',
      heroSecondaryCta: 'Conhecer o estúdio',
      introOverline: 'Quem somos',
      introTitle:
        'Trabalhamos com gente que está tentando mudar alguma coisa e precisa de tecnologia pra chegar lá.',
      introBody:
        'A gente escuta antes de propor, testa antes de entregar, e continua por perto depois que o produto vai pro ar. Do primeiro rascunho no papel até o botão de publicar, cuidamos de cada parte do processo, sem etapa terceirizada, sem promessa que a gente não consegue cumprir.',
      introBody2:
        'Não somos uma fábrica de sites nem uma consultoria de PowerPoint. Somos um estúdio pequeno o suficiente pra conhecer cada projeto pelo nome, e experiente o bastante pra dar conta dos complicados.',
      introLink: 'Sobre o estúdio',
      unitsOverline: 'Como a gente trabalha',
      unitsTitle:
        'Três frentes que se conversam, dentro do mesmo estúdio.',
      partnersOverline: 'Com quem a gente trabalha',
      partnersTitle:
        'Nossos projetos vão pro ar em parceria com organizações que movem alguma coisa no Brasil.',
      partnersList: partners,
      casesOverline: 'Trabalhos selecionados',
      casesTitle: 'Alguns projetos que a gente tem orgulho de ter feito.',
      casesLink: 'Ver todos os trabalhos',
      closingTitle: 'Curtiu?',
      closingBody:
        'A gente adora conversar sobre projeto novo. Manda um oi em',
      closingEmail: 'contato@lawork.ia.br',
    },
    units: {
      items: [
        {
          key: 'studio',
          label: 'Lawork Studio',
          headline: 'Desenvolvimento',
          body:
            'O braço que coloca a mão na massa. Plataformas, sites, sistemas internos, automações e aplicativos sob medida, construídos com carinho pelas pessoas que também pensaram o projeto.',
        },
        {
          key: 'consultoria',
          label: 'Lawork Consultoria',
          headline: 'Estratégia',
          body:
            'O trabalho invisível que faz o resto funcionar. Diagnósticos de inovação, arquitetura de produto, posicionamento digital, mapeamos o que precisa ser feito antes de sair codando.',
        },
        {
          key: 'comunicacao',
          label: 'Lawork Comunicação',
          headline: 'Voz',
          body:
            'Um produto bom precisa ser visto. Cuidamos de marca, conteúdo, campanhas e presença digital pra que a história por trás do projeto chegue nas pessoas certas.',
        },
      ],
    },
    about: {
      overline: 'Sobre a Lawork',
      title: 'Um estúdio pequeno, com trabalhos grandes.',
      lead:
        'A Lawork é uma equipe brasileira que junta tecnologia, design e comunicação em uma coisa só. A gente foi montada com uma ideia simples: fazer produto digital direito, pra quem trabalha com causa que importa.',
      body1:
        'Somos formadas em maioria por mulheres. Isso muda a forma como a gente ouve, pensa e constrói, e está na origem do jeito que fazemos as coisas.',
      body2:
        'Atendemos governos, ONGs, veículos independentes e empresas com propósito. Cada projeto começa com uma conversa longa e um caderno em branco. Não entregamos templates.',
      teamCaption:
        'Bastidor do estúdio, um dia comum de conversa e teste.',
      teamCaption2:
        'Trabalho próximo, feito à mão. Sem terceirização.',
      wayOverline: 'Nosso jeito',
      wayTitle: 'Quatro coisas que a gente não abre mão.',
      way: [
        {
          n: '01',
          title: 'A gente ouve antes.',
          description:
            'Nenhum projeto começa com solução pronta. A primeira etapa sempre é entender pra quem é, pra quê é, e o que pode dar errado.',
        },
        {
          n: '02',
          title: 'Feito à mão.',
          description:
            'Nada de template. Cada produto é desenhado do zero, do fluxo à última tipografia. Trabalho lento, e proposital.',
        },
        {
          n: '03',
          title: 'Feito por mulheres.',
          description:
            'A maior parte da nossa equipe é formada por mulheres. Isso muda a forma como conversamos, pensamos e construímos.',
        },
        {
          n: '04',
          title: 'Sem sumir depois.',
          description:
            'A gente entrega e continua junto. Manutenção, evolução, escuta contínua, o produto é vivo, e o trabalho não acaba no launch.',
        },
      ],
      closingTitle: 'Quer trabalhar com a gente?',
      closingBody: 'Manda um oi em',
    },
    services: {
      overline: 'O que fazemos',
      title: 'Três frentes, um estúdio só.',
      lead:
        'Cada projeto passa por três lentes: estratégia, construção e voz. Você pode contratar as três juntas, ou só uma, o que fizer sentido pro momento.',
      items: [
        {
          n: '01',
          label: 'Lawork Studio',
          title: 'Desenvolvimento',
          description:
            'Plataformas web, sistemas internos, sites institucionais, aplicações de dados e automações sob medida. Código escrito por quem entende do projeto, e continua junto depois que o produto vai pro ar.',
          bullets: [
            'Plataformas e sistemas web',
            'Sites institucionais',
            'Painel de dados e dashboards',
            'Automações e integrações',
            'Manutenção contínua',
          ],
        },
        {
          n: '02',
          label: 'Lawork Consultoria',
          title: 'Estratégia',
          description:
            'O trabalho de pensar antes de fazer. Ajudamos organizações a entender onde estão, onde querem chegar, e o que precisa ser construído pra sair do lugar. Diagnóstico, roadmap e arquitetura de produto.',
          bullets: [
            'Diagnóstico de inovação',
            'Posicionamento digital',
            'Arquitetura de produto',
            'Roadmap e priorização',
            'Pesquisa com usuários',
          ],
        },
        {
          n: '03',
          label: 'Lawork Comunicação',
          title: 'Voz',
          description:
            'Marca, conteúdo e presença digital. Um produto bom precisa ser visto, e a história por trás dele precisa chegar nas pessoas certas. A gente cuida do dizer.',
          bullets: [
            'Identidade visual e branding',
            'Estratégia de conteúdo',
            'Landing pages e sites narrativos',
            'Campanhas digitais',
            'Presença em redes',
          ],
        },
      ],
      closingTitle: 'Tem um projeto na cabeça?',
      closingBody: 'Manda um oi em',
    },
    portfolio: {
      overline: 'Trabalhos',
      title: 'Alguns projetos que a gente tem orgulho.',
      lead:
        'Uma seleção de trabalhos recentes, com organizações em causas que importam pra gente.',
      visit: 'Visitar site',
      internal: 'Produto interno',
      closingTitle: 'Seu projeto pode ser o próximo aqui.',
      closingBody: 'Manda um oi em',
    },
    contact: {
      overline: 'Vamos conversar',
      title: 'Manda um oi.',
      lead:
        'Curtiu o que viu? Conta pra gente qual é a sua ideia. A gente responde todo mundo, pode demorar um ou dois dias, mas responde.',
      formTitle: 'Prefere escrever aqui? Sem problema.',
      name: 'Seu nome',
      email: 'Seu e-mail',
      company: 'Empresa ou projeto (opcional)',
      message: 'Conta um pouco do que você tá pensando…',
      send: 'Enviar',
      sending: 'Enviando…',
      success: 'Mensagem enviada. A gente responde em breve.',
      labelEmail: 'E-mail',
      labelPhone: 'Telefone',
      labelWhatsapp: 'WhatsApp',
      whatsappCta: 'Chamar no WhatsApp',
      whatsappText: 'Olá! Gostaria de saber mais sobre os serviços da Lawork.',
    },
    footer: {
      tagline:
        'Estúdio de produtos digitais. Feito à mão, feito por mulheres.',
      nav: 'Navegação',
      contact: 'Contato',
      rights: 'Todos os direitos reservados.',
    },
    contactInfo,
  },

  en: {
    code: 'en',
    nav: {
      home: 'Home',
      about: 'Studio',
      services: 'What we do',
      portfolio: 'Work',
      contact: 'Contact',
      cta: 'Say hello',
    },
    home: {
      overline: 'A Brazilian digital product studio',
      heroTitle: 'We build the things that don’t exist yet.',
      heroLead:
        'Lawork is a small studio, mostly women, that designs and builds digital products for companies, governments and organizations that need to move.',
      heroPrimaryCta: 'See our work',
      heroSecondaryCta: 'About the studio',
      introOverline: 'Who we are',
      introTitle:
        'We work with people trying to change something, and needing technology to get there.',
      introBody:
        'We listen before we propose, we test before we ship, and we stick around after launch. From the first sketch on paper to the publish button, we take care of every part of the process, nothing outsourced, no promises we can’t keep.',
      introBody2:
        'We are not a website factory or a PowerPoint consultancy. We are a studio small enough to know every project by name, and experienced enough to handle the complicated ones.',
      introLink: 'About the studio',
      unitsOverline: 'How we work',
      unitsTitle: 'Three arms that talk to each other, inside the same studio.',
      partnersOverline: 'Who we work with',
      partnersTitle:
        'Our projects go live in partnership with organizations that are moving something forward in Brazil.',
      partnersList: partners,
      casesOverline: 'Selected work',
      casesTitle: 'A few projects we are proud of.',
      casesLink: 'See all work',
      closingTitle: 'Liked it?',
      closingBody: 'We love talking about new projects. Say hi at',
      closingEmail: 'contato@lawork.ia.br',
    },
    units: {
      items: [
        {
          key: 'studio',
          label: 'Lawork Studio',
          headline: 'Development',
          body:
            'The arm that gets its hands dirty. Web platforms, internal systems, websites, dashboards and tailor-made automations, built by the same people who thought through the project.',
        },
        {
          key: 'consultoria',
          label: 'Lawork Consulting',
          headline: 'Strategy',
          body:
            'The invisible work that makes everything else run. Innovation diagnostics, product architecture, digital positioning, we map what needs to be done before writing any code.',
        },
        {
          key: 'comunicacao',
          label: 'Lawork Voice',
          headline: 'Voice',
          body:
            'A good product needs to be seen. We take care of brand, content, campaigns and digital presence, so the story behind the project reaches the right people.',
        },
      ],
    },
    about: {
      overline: 'About Lawork',
      title: 'A small studio, doing bigger things.',
      lead:
        'Lawork is a Brazilian team that brings technology, design and communication together in one place. We were built around one simple idea: to make digital products properly, for people working on things that matter.',
      body1:
        'We are mostly women. That changes how we listen, how we think, and how we build, and it is at the origin of the way we do things.',
      body2:
        'We work with governments, NGOs, independent media and companies with purpose. Every project begins with a long conversation and a blank notebook. We don’t ship templates.',
      teamCaption: 'Studio backstage, a regular day of talk and testing.',
      teamCaption2: 'Close work, made by hand. Nothing outsourced.',
      wayOverline: 'The way we work',
      wayTitle: 'Four things we don’t give up on.',
      way: [
        {
          n: '01',
          title: 'We listen first.',
          description:
            'No project begins with a ready-made solution. The first step is always understanding who it is for, why, and what could go wrong.',
        },
        {
          n: '02',
          title: 'Made by hand.',
          description:
            'No templates. Every product is designed from scratch, from the flow to the final typeface. Slow work, on purpose.',
        },
        {
          n: '03',
          title: 'Made by women.',
          description:
            'Most of our team is women. That changes the way we talk, think and build.',
        },
        {
          n: '04',
          title: 'We don’t disappear.',
          description:
            'We deliver and stay close. Maintenance, evolution, continuous listening, the product is alive, and the work doesn’t end at launch.',
        },
      ],
      closingTitle: 'Want to work with us?',
      closingBody: 'Say hi at',
    },
    services: {
      overline: 'What we do',
      title: 'Three arms, one studio.',
      lead:
        'Every project passes through three lenses: strategy, build, and voice. You can hire all three, or just one, whatever fits the moment.',
      items: [
        {
          n: '01',
          label: 'Lawork Studio',
          title: 'Development',
          description:
            'Web platforms, internal systems, institutional sites, data applications and tailor-made automations. Code written by people who understand the project, and stay close after launch.',
          bullets: [
            'Web platforms and systems',
            'Institutional websites',
            'Data dashboards',
            'Automations and integrations',
            'Ongoing maintenance',
          ],
        },
        {
          n: '02',
          label: 'Lawork Consulting',
          title: 'Strategy',
          description:
            'The work of thinking before doing. We help organizations understand where they are, where they want to go, and what needs to be built to get there. Diagnostics, roadmap and product architecture.',
          bullets: [
            'Innovation diagnostics',
            'Digital positioning',
            'Product architecture',
            'Roadmap and prioritization',
            'User research',
          ],
        },
        {
          n: '03',
          label: 'Lawork Voice',
          title: 'Voice',
          description:
            'Brand, content and digital presence. A good product needs to be seen, and the story behind it needs to reach the right people. We take care of the saying.',
          bullets: [
            'Brand identity',
            'Content strategy',
            'Landing and narrative pages',
            'Digital campaigns',
            'Social presence',
          ],
        },
      ],
      closingTitle: 'Have a project in mind?',
      closingBody: 'Say hi at',
    },
    portfolio: {
      overline: 'Work',
      title: 'A few projects we’re proud of.',
      lead:
        'A selection of recent work with organizations working on causes that matter to us.',
      visit: 'Visit site',
      internal: 'Internal product',
      closingTitle: 'Your project could be the next one here.',
      closingBody: 'Say hi at',
    },
    contact: {
      overline: 'Let’s talk',
      title: 'Say hello.',
      lead:
        'Liked what you saw? Tell us what you have in mind. We answer everyone, it might take a day or two, but we do.',
      formTitle: 'Prefer to write here? No problem.',
      name: 'Your name',
      email: 'Your email',
      company: 'Company or project (optional)',
      message: 'Tell us a bit of what you are thinking…',
      send: 'Send',
      sending: 'Sending…',
      success: 'Message sent. We’ll be in touch soon.',
      labelEmail: 'Email',
      labelPhone: 'Phone',
      labelWhatsapp: 'WhatsApp',
      whatsappCta: 'Chat on WhatsApp',
      whatsappText: 'Hi! I’d like to know more about Lawork’s services.',
    },
    footer: {
      tagline:
        'A Brazilian digital product studio. Made by hand, made by women.',
      nav: 'Navigation',
      contact: 'Contact',
      rights: 'All rights reserved.',
    },
    contactInfo,
  },
};
